import React from 'react';
import ReactDOM from 'react-dom';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { uuid } from 'utils/utils';

import styles from './ToolTip.module.scss';

const s = classNames.bind(styles);

/**
|--------------------------------------------------
| This components extends the react-tooltip library.
| Full api documentation here:
| https://github.com/wwayne/react-tooltip
| https://react-tooltip.netlify.com/
|--------------------------------------------------
*/
const ToolTip = ({ text, children, placement, disabled, className, toolTipClassName, id, component }) => {
	if (disabled) return children;
	const uniq = id || uuid();
	return (
		<React.Fragment>
			<div data-tip data-for={uniq} className={s({ [className]: className })}>
				{children}
			</div>
			{ReactDOM.createPortal(
				<ReactTooltip
					className={s('tooltip', {
						[toolTipClassName]: toolTipClassName
					})}
					id={uniq}
					place={placement}
					type="dark"
					effect="solid"
					delayShow={500}
					delayUpdate={500}
				>
					{text ? <span>{text}</span> : null}
					{component || null}
				</ReactTooltip>,
				document.getElementById('root')
			)}
		</React.Fragment>
	);
};

ToolTip.propTypes = {
	text: PropTypes.string,
	placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	className: PropTypes.string,
	toolTipClassName: PropTypes.string,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	children: PropTypes.object, // The button, text or what it maybe
	disabled: PropTypes.bool,
	component: PropTypes.node
};

ToolTip.defaultProps = {
	placement: 'top'
};

export default ToolTip;
